module.exports = __webpack_public_path__ + "static/media/splash.4a7b9234.jpg";